import { useDailySunlightStore } from '@/store/dailySunlightsStore';
import styles from './styles.module.scss';
import { useEffect, useState, useCallback } from 'react';
import { FacadePointData } from './FacadePointData';
import { FacadeWallData } from './FacadeWallData';

export const FacadeTooltip = () => {
	const hoveredFacadeData = useDailySunlightStore((state) => state.hoveredFacadeData);
	const facadeWallData = useDailySunlightStore((state) => state.facadeWallData);
	const facadeTabIndex = useDailySunlightStore((state) => state.facadeTabIndex);
	const setFacadeTabIndex = useDailySunlightStore((state) => state.setFacadeTabIndex);
	const [tabIndex, setTabIndex] = useState(facadeTabIndex);

	const handleKeyDown = useCallback((event: KeyboardEvent) => {
		if (event.key === 'Tab') {
			event.preventDefault();
			setTabIndex((prev) => {
				const newIndex = prev === 0 ? 1 : 0;
				setFacadeTabIndex(newIndex);
				return newIndex;
			});
		}
		if (event.key === '1') {
			setTabIndex(0);
			setFacadeTabIndex(0);
		}
		if (event.key === '2') {
			setTabIndex(1);
			setFacadeTabIndex(1);
		}
	}, [setFacadeTabIndex]);

	useEffect(() => {
		document.addEventListener('keydown', handleKeyDown);

		return () => {
			document.removeEventListener('keydown', handleKeyDown);
		};
	}, [handleKeyDown]);

	useEffect(() => {
		setTabIndex(facadeTabIndex);
	}, [facadeTabIndex]);

	if (!hoveredFacadeData) return null;

	const hasWallData = facadeWallData && facadeWallData.length > 0;

	return (
		<div className={styles.facadeTooltip}>
			{hasWallData && (
				<div className={styles.tabBar}>
					<kbd className={tabIndex === 0 ? styles.active : ''}>1</kbd>
					<kbd className={tabIndex === 1 ? styles.active : ''}>2</kbd>
					<span className={styles.tabHint}>Tab/1/2 to switch views</span>
				</div>
			)}
			{tabIndex === 0 && <FacadePointData data={hoveredFacadeData} />}
			{tabIndex === 1 && hasWallData && <FacadeWallData data={facadeWallData} />}
		</div>
	);
};

